var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[(_vm.isShowTitle)?_c('CartsTitle',{attrs:{"title":"我的收藏"}}):_vm._e(),_c('div',{staticClass:"table-container"},[_c('Table',{attrs:{"obj":_vm.tabList[0].data},on:{"sizeChange":_vm.sizeChange,"pageChange":_vm.pageChange,"refreshChange":_vm.refreshChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }